import { useMemo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ClbLoading } from '@celebration/react';
import i18n from '../../../../../lib/i18n';
import OfferCard from '../offer-card/offer-card';
import { useOffersRound } from '../../../../../app/contexts/offers-round/offers-round.context';
import './offers-list.scss';

export default function OffersList() {
    const {
        acceptanceOffersList,
        acceptanceError,
        fetchNextPageByPosition,
        acceptanceHasMore,
        roundState,
    } = useOffersRound();

    const offersListEndMessage = useMemo(() => {
        if (acceptanceError !== undefined) {
            if (acceptanceError === 'RoundNotFoundException') {
                return (
                    <h2 data-testid="no-rounds-error-message">
                        {i18n.t('SmartCargas.Rounds.NoRounds')}
                    </h2>
                );
            }
            if (acceptanceError === 'CarrierNotFoundException') {
                return (
                    <h2 data-testid="carrier-error-message">
                        {i18n.t('SmartCargas.Rounds.CarrierError')}
                    </h2>
                );
            }
            return (
                <h2 data-testid="fetch-offers-error-message">
                    {i18n.t('CargasErroConsultar')}
                </h2>
            );
        }

        if (acceptanceOffersList.length > 0) {
            return (
                <h2 data-testid="showing-all-offers-message">
                    {i18n.t('CargasTodasJaExibidas')}
                </h2>
            );
        }

        return (
            <h2 data-testid="no-offers-message">
                {i18n.t('CargasExibirNenhuma')}
            </h2>
        );
    }, [acceptanceOffersList, acceptanceError]);

    return (
        <div data-testid="offers-list-scroll">
            {roundState.status === 'active' && (
                <InfiniteScroll
                    className="offers-list"
                    dataLength={acceptanceOffersList.length}
                    next={() => fetchNextPageByPosition(1)}
                    hasMore={acceptanceHasMore.current}
                    loader={<ClbLoading />}
                    endMessage={offersListEndMessage}
                    scrollableTarget="offers-content"
                >
                    {acceptanceOffersList.length > 0 &&
                        acceptanceOffersList.map(offer => (
                            <OfferCard key={offer.loadOfferId} offer={offer} />
                        ))}
                </InfiniteScroll>
            )}
            {(roundState.status === 'loadingOffers' ||
                roundState.status === 'filtering') && <ClbLoading size="lg" />}
        </div>
    );
}
